import moment from 'moment'

import { PURCHASE_FLOW } from 'subscription-flow/constants'

export const limitMonths = months => date => {
    const today = moment()
    const limit = today.clone().add(months, 'M').endOf('M')
    return date.isBefore(today, 'day') || date.isAfter(limit, 'day')
}

export const useFlow = (filterSteps = []) => PURCHASE_FLOW.filter(step => filterSteps.indexOf(step) === -1)
